import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  input: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#666666',
  },
  addingInvoiceInput: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '20px',
    color: '#666666',
    paddingLeft: ' 0 !important',
  },
  autocompleteAddingInvoice: {
    width: 140,
    height: 40,
  },
  autocomplete: {
    margin: '8px 16px',
    width: 220,
  },
  option: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '18px',
    color: '#666666',
  },
  inputRoot: {
    padding: '8px !important',
  },
  helperText: {
    marginLeft: 0,
    marginRight: 0,
    fontSize: '10px',
  },
}));
